import type React from "react";
import { cn } from "../utils/cn";

interface JourneysIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  title?: string;
  dark?: boolean;
}

export function JourneysIcon({ className, title = "Journeys Icon", dark, ...props }: JourneysIconProps) {
  // Ensure title is never empty for accessibility
  const accessibleTitle = title || "Journeys Icon";

  return (
    <svg
      className={cn(className)}
      aria-label={accessibleTitle}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{accessibleTitle}</title>
      <path
        d="M13.9141 3.58984H6.08789V9.28223C6.08789 10.4469 6.51286 11.5534 7.25391 12.3604C7.99325 13.1654 8.98332 13.6055 10.001 13.6055C11.0185 13.6053 12.0078 13.1653 12.7471 12.3604C13.4882 11.5534 13.9141 10.447 13.9141 9.28223V3.58984ZM15.3115 9.33594C15.5174 9.23935 15.7104 9.10123 15.877 8.91992C16.2248 8.54112 16.4296 8.01526 16.4297 7.45605C16.4297 6.89677 16.2249 6.37103 15.877 5.99219C15.7106 5.81107 15.519 5.67083 15.3135 5.57422V9.28223C15.3135 9.30011 15.3117 9.31807 15.3115 9.33594ZM3.57129 7.45605C3.57134 8.01526 3.77613 8.54112 4.12402 8.91992C4.29041 9.101 4.48291 9.23936 4.68848 9.33594L4.6875 9.28223V5.57422C4.48193 5.67083 4.2904 5.81107 4.12402 5.99219C3.77608 6.37103 3.57129 6.89677 3.57129 7.45605ZM17.8301 7.45605C17.83 8.34988 17.5039 9.21753 16.9082 9.86621C16.4247 10.3926 15.7933 10.7407 15.1074 10.8545C14.865 11.7688 14.4141 12.6154 13.7783 13.3076C12.9508 14.2086 11.8672 14.7863 10.7002 14.9531V17.7432H9.30078V14.9531C8.13379 14.7863 7.05009 14.2086 6.22266 13.3076C5.58686 12.6153 5.13497 11.7688 4.89258 10.8545C4.20704 10.7405 3.57603 10.3924 3.09277 9.86621C2.49705 9.21752 2.17095 8.34989 2.1709 7.45605C2.1709 6.5621 2.49695 5.69367 3.09277 5.04492L3.20703 4.92676C3.62273 4.51692 4.13352 4.23058 4.6875 4.09863V2.18945H15.3135V4.09863C15.9193 4.24294 16.4736 4.57177 16.9082 5.04492C17.504 5.69367 17.8301 6.5621 17.8301 7.45605Z"
        fill={dark ? "white" : "black"}
      />
      <line x1="6" y1="17.3" x2="14" y2="17.3" stroke={dark ? "white" : "black"} stroke-width="1.4" />
    </svg>
  );
}

export default JourneysIcon;
